<template>
	<div class="menu">
		<div class="menu-container">
			<div @mouseleave="selectCategory(null, null, false)">
				<div
					type="button"
					class="menu-btn w-100"
					v-for="(category, indexCat) in categories" :key="indexCat"
					:style="`background-color:${activeCategory(category) ? globalColors.border : 'white'};border-left: 1.5rem solid ${activeCategory(category) ? globalColors.primary : 'white'};`"
					@mouseenter="selectCategory($event, category, true)"
					@click="goToCategory(category)"
				>
					<img :src="category.mobileImage" />
					<span class="category-title">{{category.title}}</span>
				</div>
				<transition name="fade-lateral" mode="out-in">
					<div
						class="hidden-menu absolute"
						v-show="onShowingMenu"
						@mouseleave="selectCategory(null, null, false)"
						@mouseover="selectCategory(null, null, true)"
					>
						<div class="wrapper-product-container">
							<div class="grid-system">
								<div
									class="product-container"
									v-for="(item, indexItem) in currentCategory.detail"
									:key="indexItem"
								>
									<div class="product-title-container" @click="goToCategory(item)">
										<p
											class="product-title"
											:style="`border-bottom: 0.2rem solid ${globalColors.primary};`"
										>{{item.title}}</p>
										<div class="product-description">
											<img :src="item.urlImage" alt="imagen de la Categpría">
											<span>{{item.description}}</span>
										</div>
									</div>
								</div>
							</div>
							<div
								class="pointer absolute"
								:style="positioning"
							></div>
						</div>
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>
<script>
import lib from '@/helpers/lib';

const { debounce } = lib;

function goToCategory({ slug, id }) {
	this.$router.push({ name: 'categories', params: { slug: slug || id, categoryId: id } });
	this.$emit('category-changed');
}

function handlerRoute(newRoute) {
	this.id = newRoute.params.id;
	this.$emit('change', this.id);
}

function selectCategory(args) {
	const [e, category, flag] = args;
	if (e && category) {
		this.y = e.target.offsetTop;
		this.currentCategory = { ...category };
	}
	this.showMenu = flag;
}

function positioning() {
	return `top: ${this.y}px`;
}

function activeCategory(category) {
	return (this.currentCategory && this.currentCategory.id) === category.id;
}

function closeCategoryMenu() {
	this.showMenu = false;
	this.currentCategory = {};
}

function onMenu() {
	this.showMenu = true;
}

function onShowingMenu() {
	return this.showMenu && this.currentCategory.detail.length > 0;
}

function data() {
	return {
		id: null,
		currentCategory: {},
		showMenu: false,
		y: 0,
	};
}

export default {
	name: 'menu-web',
	computed: {
		onShowingMenu,
		positioning,
	},
	data,
	methods: {
		activeCategory,
		closeCategoryMenu,
		goToCategory,
		onMenu,
		selectCategory: debounce(selectCategory),
	},
	props: {
		categories: {
			default: () => [],
			type: Array,
		},
	},
	watch: {
		$route: {
			handler: handlerRoute,
			deep: true,
		},
	},
};
</script>
<style lang="scss" scoped>
	.btn-product {
		align-items: center;
		background-color: white;
		border: none;
		color: color(textBoldGrey);
		cursor: pointer;
		display: grid;
		font-size: size(medium);
		font-weight: bold;
		grid-gap: 1rem;
		grid-template-columns: 5rem 1fr;
		height: 8rem;

		img {
			height: 100%;
			object-fit: contain;
			width: 100%;
		}

		span {
			white-space: nowrap;
		}
	}

	.menu {
		display: none;
		font-family: font(avenir);

		@media (min-width: 767px) {
			display: grid;
			flex: 1 1 15%;
			position: relative;
		}
	}

	.menu-container {
		overflow-x: hidden;
		overflow-y: auto;
	}

	.menu-btn {
		align-items: center;
		border-bottom: 0.1rem solid color(lightGrey);
		box-sizing: border-box;
		cursor: pointer;
		display: grid;
		height: 4rem;
		grid-gap: 1rem;
		grid-template-columns: 15% 85%;
		padding-left: 2.2rem;
		text-align: left;
		transition: all .1s ease-in;

		img {
			height: 2.5rem;
			width: 2.5rem;
		}
	}

	.category-active {
		background-color: color(veryLightGrey);
		padding-left: 0.7rem;
	}

	.wrapper-product-container{
		width: 100%;
	}

	.hidden-menu {
		background-color: white;
		box-shadow: 0 2px 5px 0 rgba(83, 83, 83, 0.5);
		left: 107.5%;
		padding: 3rem 4rem 1rem;
		top: 0;
		max-width: 100rem;
		z-index: 4;
	}

	.pointer {
		border-bottom: 1.3rem solid transparent;
		border-right: 1.3rem solid white;
		border-top: 1.3rem solid transparent;
		height: 0;
		right: 100%;
		width: 0;
	}

	.product-title-container {
		background-color: transparent;
		border: none;
		cursor: pointer;
		margin-bottom: 2rem;
		white-space: nowrap;
	}

	.product-title {
		font-family: font(avenir);
		font-size: size(normal);
		font-weight: bold;
		max-width: 20rem;
		overflow: hidden;
		text-overflow: ellipsis;
		width: 100%;
	}

	.product-description {
		align-items: center;
		display: grid;
		grid-column-gap: 1.5rem;
		grid-row-gap: 1rem;
		grid-template-columns: 5rem 9rem;
		grid-template-rows: 5rem;

		img {
			height: 100%;
			object-fit: contain;
			width: 100%;
		}

		span {
			white-space: pre-wrap;
		}
	}

	.grid-system {
		display: grid;
		grid-gap: 1rem;
		grid-template-columns: repeat(5, 1fr);
	}

	.category-title {
		font-size: size(medium);
	}
</style>



// WEBPACK FOOTER //
// menuWeb.vue?49df8076